








































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ReserveType } from '@/types'

export interface ReserveSetGroupEditInfoItem {
  hasRank: {
    input: boolean
  }
}

export const defaultReserveSetGroupEditInfoItem = (): ReserveSetGroupEditInfoItem => ({
  hasRank: {
    input: false
  }
})

@Component({
  components: {}
})
export default class ReserveSetGroupEditInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: ReserveSetGroupEditInfoItem

  @Prop({
    type: String,
    required: true
  })
  reserveType!: ReserveType

  get isReserveTypeSet(): boolean {
    return this.reserveType === ReserveType.Set
  }
}
